import { ChangeDetectionStrategy, Component, computed, input, output, ViewEncapsulation } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { CelumIcon, IconConfiguration } from '@celum/common-components/icon';
import { SpaceAwareTooltipDirective } from '@celum/ng2base/directives';

@Component({
  selector: 'celum-chip',
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.scss',
  imports: [MatChipsModule, MatTooltipModule, TranslateModule, CelumIcon, SpaceAwareTooltipDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class CelumChipComponent {
  public prefixIcon = input<string>();
  public prefix = input<string>();
  public text = input<string>();
  public color = input<'light' | 'dark'>('dark');
  public disabled = input(false);
  public errorTooltip = input<string>();
  public closeIcon = input<string | IconConfiguration>('cancel-m');
  public closeIconTooltip = input<string>();
  public readonly remove = output<boolean>();

  protected closeIconConfig = computed(() => {
    const icon = this.closeIcon();
    return typeof icon === 'string' ? new IconConfiguration(icon).withIconSize(16) : icon;
  });
  protected prefixIconConfig = computed(() => this.prefixIcon() && new IconConfiguration(this.prefixIcon()).withIconSize(16).withColor('inherit'));
}
